import { computed } from '@vue/composition-api';
import _ from 'lodash';

import { useSessions } from '@/modules/sessions-store';
import { useEvents, useNewEvents } from '@/modules/events-store';
import { ISession } from '@/types';
import { getLastTranscript } from '@/common';

export const useContactSessions = () => {
  const { getSessionsOrderByProperty } = useSessions();
  const { getEventsBySessionId } = useEvents();
  const { getNewContentEventsCount } = useNewEvents();

  const allSessions = computed(() => {
    return getSessionsOrderByProperty.value({
      applyFilter: true,
    });
  });

  const sessionsByContactId = computed(() => {
    return _.groupBy(allSessions.value, 'contactId');
  });

  const latestMessageBySessionId = computed(() => {
    const lastMessageBySessionId = allSessions.value.reduce((
      accumulator: Record<string, string>,
      session: ISession,
    ) => {
      const events = getEventsBySessionId.value(session.sessionId);
      const transcript = getLastTranscript({ events });

      accumulator[session.sessionId] = _.get(transcript, 'eventValue.Message')!;
      return accumulator;
    }, {});

    return lastMessageBySessionId;
  });

  const newEventsBySessionId = computed(() => {
    const result: Record<string, number> = {};
    for (const session of allSessions.value) {
      const sessionId = session.hitlSessionId;
      result[sessionId] = getNewContentEventsCount.value(sessionId);
    }
    return result;
  });

  return {
    allSessions,
    sessionsByContactId,
    latestMessageBySessionId,
    newEventsBySessionId,
  };
};
